import type { AllTests } from '@core/abTesting/types'

export const allTests: AllTests = new Map()
